import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';

/**
 *
 * @returns {인풋 페이지 - 인풋들 감싸는 구획}
 */
interface IProps {
  children: JSX.Element | JSX.Element[];
  left?: boolean;
  style?: React.CSSProperties;
  disable?: boolean;
}
const InputWrappingBox: React.FC<IProps> = ({
  children,
  left,
  style,
  disable,
  ...props
}) => {
  return (
    <InputContainer left={left} style={style} disable={disable} {...props}>
      {children}
    </InputContainer>
  );
};

export default InputWrappingBox;

const InputContainer = styled.div<IProps>`
  background-color: #fff;
  width: 100%;
  height: fit-content;
  opacity: ${(props) => (props.disable ? 0.5 : 1)};
  pointer-events: ${(props) => (props.disable ? 'none' : 'all')};
  /* height: 80vh; */
  /* max-height: 79vh;
  overflow: auto; */
  margin-right: ${(props) => (props.left ? '2.5rem' : '0rem')};
  border-radius: 8px;
  padding: 1.5rem 1.5rem;
  border: 1px solid ${theme.colors.dark_100};
  /* 드롭존 이미지 */
  .filepond--root {
    width: 100%;
  }
`;
